module.exports = __webpack_public_path__ + "static/media/ic_28px_Notification_happy_face.edab19f9.svg";